import { memo } from "react";
import { cn } from "@/lib/utils";
import { Skeleton } from "@/components/ui/skeleton";

interface PosterLandscapeCardSkeletonProps {
  className?: string;
}

const PosterLandscapeCardSkeleton = ({ className }: PosterLandscapeCardSkeletonProps) => {
  return (
    <article className={cn("overflow-hidden rounded-2xl shadow-none p-0 gap-0 p-1 border bg-white", className)}>
      <div className="flex items-start gap-2">
        <Skeleton className="relative w-[190px] h-[145px] rounded-xl shrink-0" />

        <section className="space-y-1.5 py-1 flex-1">
          <div className="flex flex-row gap-2">
            <Skeleton className="h-4 w-4 rounded-full" />
            <Skeleton className="h-4 w-4 rounded-full" />
            <Skeleton className="h-4 w-4 rounded-full" />
            <Skeleton className="h-4 w-4 rounded-full" />
          </div>

          <div className="flex items-center gap-1.5">
            <Skeleton className="h-3.5 w-3.5 rounded-full shrink-0" />
            <Skeleton className="h-3.5 w-20" />
          </div>

          <div className="flex items-center gap-1.5">
            <Skeleton className="h-4 w-4 rounded-full shrink-0" />
            <Skeleton className="h-3.5 w-24" />
          </div>
        </section>
      </div>

      <div className="flex items-end justify-between gap-2 p-2">
        <div className="flex h-12 min-w-0 flex-1 flex-col justify-end gap-1">
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-3/4" />
        </div>

        <div className="flex flex-col items-end shrink-0 gap-1">
          <Skeleton className="h-3 w-14" />
          <Skeleton className="h-5 w-16" />
        </div>
      </div>
    </article>
  );
};

export default memo(PosterLandscapeCardSkeleton);